import React from 'react'
import PropTypes from 'prop-types'

const ModalWide = ({ className = 'bg-white w-full mx-auto rounded shadow-lg z-50', children }) => (
  <div className={`modal-container ${className}`}>{children}</div>
)

ModalWide.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

export default ModalWide
